import FormField from './field.js';

export default class Button extends FormField {
    constructor(parent, el) {
        super(parent, el);
        this.button = el.querySelector('a');
        this.func = this.parse(this.button.dataset.func);
        this.bind();
    }

    bind() {
        if(this.func) {
            this.button.addEventListener('click', (e) => {
                e.preventDefault();
                this.func(this);
            });
        }
    }

    parse(funcStr) {
        if(funcStr) {
            try {
                return new Function("field", funcStr);
            } catch(err) {
                console.error(err);       
            }
        }
    }
    
    static is(el) {
        return super.is(el) && el.classList.contains('form_field_button');
    }
}